import { Checkbox, FormControlLabel } from "@mui/material";
import { ChangeEvent, ReactNode } from "react";
import { Controller } from "react-hook-form";
import { Control, Path, FieldValues } from "react-hook-form/dist/types";

interface IFormCheckboxProps<TFieldValues extends FieldValues = FieldValues> {
  id: string;
  label: string | ReactNode;
  fieldName?: Path<TFieldValues> | undefined;
  fieldControl?: Control<TFieldValues, any> | undefined;
  onChange?: ((event: ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
}

export default function FormCheckbox<TFieldValues extends FieldValues = FieldValues>({
  id,
  label,
  fieldName,
  fieldControl,
  onChange
}: IFormCheckboxProps<TFieldValues>) {
  return (
    <FormControlLabel
      id={id}
      className="mt-0 -ml-2"
      sx={{ mt: 1, ml: -1 }}
      label={label}
      control={
        fieldControl && fieldName ? (
          <Controller
            name={fieldName}
            control={fieldControl}
            render={({ field }) => (
              <Checkbox
                id={field.name}
                inputRef={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(ev, checked) => {
                  onChange?.(ev, checked);
                  field.onChange(ev, checked);
                }}
                disableTouchRipple
              />
            )}
          />
        ) : (
          <Checkbox onChange={onChange} disableTouchRipple />
        )
      }
    />
  );
}
